import React from 'react';
import { Captions } from 'lucide-react';
import { TabBtn } from '../../shared/ui/tab-btn';
import { useEditorCanvas } from '../../canvas/hooks/use-editor-canvas';
import { usePanels } from '../../shared/hooks/use-panels';
import { useBrandKit } from '../../brand-kit';
import { SobreimpresoPresetsPanel } from './presets-panel';

export const TextOverlayButton: React.FC = () => {
  const { addSobreimpreso } = useEditorCanvas();
  const { toggle, isOpen } = usePanels();
  const { sobreimpresoPresets } = useBrandKit();

  const hasPresets = !!sobreimpresoPresets?.length;

  return (
    <>
      <TabBtn
        panelId={hasPresets ? 'sobreimpresoPresets' : undefined}
        onClick={hasPresets ? () => toggle('sobreimpresoPresets') : () => addSobreimpreso()}
        label='Text overlay'
        icon={<Captions size={18} />}
        active={hasPresets && isOpen('sobreimpresoPresets')}
      />
      {hasPresets && <SobreimpresoPresetsPanel />}
    </>
  );
};
